export default {
    columns: [
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.procedure.id.description",//"Código interno de la solicitud",
          label: "wkt.admin.qbuilder.model.procedure.id.text",//"Código solicitud",
          field: "id"
        },
        {
          field: "requestDate",
          type: "DATETIME",
          desc: "wkt.admin.qbuilder.model.procedure.date.description",//"Fecha de la solicitud",
          label: "wkt.admin.qbuilder.model.procedure.date.text",//"F. Solicitud",
          formatter: 'formatDateTime'
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.procedure.employee-id.description",//"Código interno trabajador",
          label: "wkt.admin.qbuilder.model.procedure.employee-id.text",//"Código trabajador",
          field: "employeeId"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.procedure.employee-firstname.description",//"Nombre del trabajador",
          label: "wkt.admin.qbuilder.model.procedure.employee-firstname.text",//"Nombre",
          field: "employeeFirstname"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.procedure.employee-lastname.description",//"Apellidos del trabajador",
          label: "wkt.admin.qbuilder.model.procedure.employee-lastname.text",//"Apellidos",
          field: "employeeLastname"
        },
                {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.procedure.employee-id-number.description",//"Documento identificativo",
          label: "wkt.admin.qbuilder.model.procedure.employee-id-number.text",//"Documento ID",
          field: "employeeIdNumber"
        },
        {
          field: "employeeUsername",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.procedure.employee-username.description",//"Nombre de usuario",
          label: "wkt.admin.qbuilder.model.procedure.employee-username.text",//"Usuario"
        },
        {
          field: "employeeReference",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.procedure.employee-reference.description",//"Referencia del trabajador",
          label: "wkt.admin.qbuilder.model.procedure.employee-reference.text",//"Referencia trabajador"
        },
        {
          field: "workplaceId",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.procedure.workplace-id.description",//"Código del centro de trabajo",
          label: "wkt.admin.qbuilder.model.procedure.workplace-id.text",//"Código centro trabajo"
        },
        {
          field: "workplaceName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.procedure.workplace-name.description",//"Nombre Centro de trabajo",
          label: "wkt.admin.qbuilder.model.procedure.workplace-name.text",//"Centro trabajo"
        },
        {
          field: "departmentId",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.procedure.department-id.description",//"Código del departamento",
          label: "wkt.admin.qbuilder.model.procedure.department-id.text",//"Código departamento"
        },
        {
          field: "departmentName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.procedure.department-name.description",//"Nombre Departamento",
          label: "wkt.admin.qbuilder.model.procedure.department-name.text",//"Departamento"
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.procedure.type-id.description",//"Código interno tipo de solicitud",
          label: "wkt.admin.qbuilder.model.procedure.type-id.text",//"C. tipo solicitud",
          field: "requestTypeId"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.procedure.type-name.description",//"Nombre tipo de solicitud",
          label: "wkt.admin.qbuilder.model.procedure.type-name.text",//"Tipo solicitud",
          field: "requestTypeName"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.procedure.type-reference.description",//"Referencia tipo de solicitud",
          label: "wkt.admin.qbuilder.model.procedure.type-reference.text",//"Ref. Tipo solicitud",
          field: "requestTypeReference"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.procedure.title.description",//"Nombre de la solicitud",
          label: "wkt.admin.qbuilder.model.procedure.title.text",//"Nombre solicitud",
          field: "requestTitle"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.procedure.info.description",//"Información adicional",
          label: "wkt.admin.qbuilder.model.procedure.info.text",//"Otra información",
          field: "requestInfo"
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.procedure.project-id.description",//"Código interno proyecto",
          label: "wkt.admin.qbuilder.model.procedure.project-id.text",//"C. proyecto",
          field: "projectId"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.procedure.project-name.description",//"Nombre de proyecto asociado",
          label: "wkt.admin.qbuilder.model.procedure.project-name.text",//"Proyecto",
          field: "projectShortName"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.procedure.project-reference.description",//"Referencia proyecto asociado",
          label: "wkt.admin.qbuilder.model.procedure.project-reference.text",//"Ref. proyecto",
          field: "projectReference"
        },
        {
          type: "SIMPLEDATE",
          desc: "wkt.admin.qbuilder.model.procedure.from-date.description",//"Fecha inicial indicada en la solicitud",
          label: "wkt.admin.qbuilder.model.procedure.from-date.text",//"Fecha inicial",
          field: "fromDate",
          formatter: "formatSimpleDate"
        },
        {
          type: "SIMPLEDATE",
          desc: "wkt.admin.qbuilder.model.procedure.to-date.description",//"Fecha final indicada en la solicitud",
          label: "wkt.admin.qbuilder.model.procedure.to-date.text",//"Fecha final",
          field: "toDate",
          formatter: "formatSimpleDate"
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.procedure.quantity.description",//"Cantidad indicada en la solicitud",
          label: "wkt.admin.qbuilder.model.procedure.quantity.text",//"Cantidad",
          field: "quantity"
        },
        {
          field: "requestStatus",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.procedure.status.description",//"Estado de la solicitud",
          label: "wkt.admin.qbuilder.model.procedure.status.text",//"Estado",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.qbuilder.model.procedure.choices.pending',/*'Pendiente'*/ },
                     { 'key':'1', 'value':'wkt.admin.qbuilder.model.procedure.choices.approved',/*'Aprobada'*/ },
                     { 'key':'2', 'value':'wkt.admin.qbuilder.model.procedure.choices.rejected',/*'Rechazada'*/ },
                     { 'key':'4', 'value':'wkt.admin.qbuilder.model.procedure.choices.completed',/*'Procesada'*/ } ]
        },
        {
          type: "DATETIME",
          desc: "wkt.admin.qbuilder.model.procedure.approved-date.description",//"Fecha en la que se aprueba la solicitud",
          label: "wkt.admin.qbuilder.model.procedure.approved-date.text",//"Fecha aprobada",
          field: "approvedDate",
          formatter: "formatDateTime"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.procedure.approver-employee-ids.description",//"Código interno de los supervisores que aprueban la solicitud",
          label: "wkt.admin.qbuilder.model.procedure.approver-employee-ids.text",//"Código supervisores",
          field: "approverEmployeeIds"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.procedure.approver-employee-names.description",//"Nombre de los supervisores que aprueban la solicitud",
          label: "wkt.admin.qbuilder.model.procedure.approver-employee-names.text",//"Supervisores",
          field: "approverEmployeeNames"
        },
      ],
}